var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{staticStyle:{"position":"relative"},attrs:{"columns":_vm.podColumns,"data":_vm.podData,"size":"small","max-height":"400"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }